/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TokenV2ReponseType = {
    Token: 'token',
    ChallengeList: 'challenge_list'
} as const;
export type TokenV2ReponseType = typeof TokenV2ReponseType[keyof typeof TokenV2ReponseType];


export function TokenV2ReponseTypeFromJSON(json: any): TokenV2ReponseType {
    return TokenV2ReponseTypeFromJSONTyped(json, false);
}

export function TokenV2ReponseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenV2ReponseType {
    return json as TokenV2ReponseType;
}

export function TokenV2ReponseTypeToJSON(value?: TokenV2ReponseType | null): any {
    return value as any;
}

